import React from 'react';
import {
  BaseMixin,
  ElementaryMixin,
  NestingLevelMixin,
  ContentMixin,
  ColorSchemaMixin,
  LevelMixin
} from '../common/common.js';
import Environment from '../environment/environment.js';
import Jumbotron from './jumbotron.js'

import './header.less';

export const Header = React.createClass({

  //@@viewOn:mixins
  mixins: [
    BaseMixin,
    ElementaryMixin,
    NestingLevelMixin,
    ContentMixin,
    ColorSchemaMixin,
    LevelMixin
  ],
  //@@viewOff:mixins

  //@@viewOn:statics
  statics: {
    tagName: 'UU5.Bricks.Header',
    nestingLevelList: Environment.getNestingLevelList('bigBoxCollection', 'box'),
    classNames: {
      main: 'uu5-bricks-header',
      text: 'uu5-common-text'
    }
  },
  //@@viewOff:statics

  //@@viewOn:propTypes
  //@@viewOff:propTypes

  //@@viewOn:getDefaultProps
  //@@viewOff:getDefaultProps

  //@@viewOn:standardComponentLifeCycle
  //@@viewOff:standardComponentLifeCycle

  //@@viewOn:interface
  //@@viewOff:interface

  //@@viewOn:overridingMethods
  //@@viewOff:overridingMethods

  //@@viewOn:componentSpecificHelpers
  //@@viewOff:componentSpecificHelpers

  //@@viewOn:render
  render: function () {
    var level = this.getLevel();
    var result;

    if (level > 0) {
      var attrs = this.buildMainAttrs();
      attrs.className += ' ' + this.getClassName().text;
      // this.props.background && (attrs.className += ' ' + this.getClassName().bg);

      result = React.createElement(
        'h' + level,
        attrs,
        this.getChildren(),
        this.getDisabledCover()
      );
    } else {
      let className = this.getClassName().main;
      this.props.className && (className += ' ' + this.props.className);

      result = (
        <Jumbotron
          disabled={this.isDisabled()}
          hidden={this.isHidden()}
          selected={this.isSelected()}
          colorSchema={this.props.colorSchema}
          className={className}
        >
          <h1>{this.getChildren()}</h1>
        </Jumbotron>
      )
    }

    return this.getNestingLevel() ? result : null;
  }
  //@@viewOff:render
});

export default Header;



// WEBPACK FOOTER //
// ./bricks/header.js